<div
  (click)="closeZoomModal()"
  *ngIf="isModalOpen"
  class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 px-2"
>
  <div class="relative flex items-center w-full max-w-screen-xl justify-center">
    <!-- Flecha izquierda - solo desktop -->
    <button
      *ngIf="images && images.length > 1"
      (click)="onPrevClick(); $event.stopPropagation()"
      class="hidden md:flex text-primary hover:text-secondary bg-white bg-opacity-90 hover:bg-opacity-100 transition-all p-3 rounded-full shadow-lg z-50 mr-3 flex-shrink-0"
      aria-label="Imagen anterior"
    >
      <i class="fas fa-chevron-left text-xl"></i>
    </button>

    <div class="relative bg-white p-2 md:p-4 rounded-lg">
      <!-- Botón cerrar -->
      <button
        (click)="closeZoomModal(); $event.stopPropagation()"
        type="button"
        aria-label="Cerrar"
        class="modal-close-btn absolute -top-2 -right-2 md:-top-3 md:-right-3 text-primary z-50 bg-white rounded-full inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 shadow-lg hover:bg-gray-100 transition-colors"
      >
        <mat-icon class="modal-close-icon" aria-hidden="true">close</mat-icon>
      </button>

      <!-- Mostrar visor 360 si la imagen actual es 360 -->
      <div
        *ngIf="isCurrentImage360()"
        (click)="$event.stopPropagation()"
        class="flex items-center justify-center rounded overflow-hidden"
        style="width: 80vw; height: 65vh; max-width: 1000px"
      >
        <app-image-360-viewer
          [images]="images360"
          [productName]="productName"
          [disableModal]="true"
        >
        </app-image-360-viewer>
      </div>

      <!-- Mostrar imagen normal si no es 360 -->
      <div
        *ngIf="!isCurrentImage360()"
        class="flex items-center justify-center rounded overflow-hidden"
        style="width: 80vw; height: 65vh; max-width: 1000px"
      >
        <img
          [src]="zoomImageSrc"
          alt="Imagen de zoom"
          class="object-contain w-full h-full"
          (click)="$event.stopPropagation()"
          (touchstart)="onTouchStart($event)"
          (touchmove)="onTouchMove($event)"
          (touchend)="onTouchEnd()"
        />
      </div>

      <!-- Indicador de imagen actual -->
      <div
        class="absolute -bottom-8 md:-bottom-10 left-1/2 transform -translate-x-1/2 text-white bg-black bg-opacity-60 px-3 py-1 md:px-4 md:py-2 rounded-full text-xs md:text-sm z-30"
      >
        {{ selectedIndex + 1 }} / {{ images.length }}
      </div>
    </div>

    <!-- Flecha derecha - solo desktop -->
    <button
      *ngIf="images && images.length > 1"
      (click)="onNextClick(); $event.stopPropagation()"
      class="hidden md:flex text-primary hover:text-secondary bg-white bg-opacity-90 hover:bg-opacity-100 transition-all p-3 rounded-full shadow-lg z-50 ml-3 flex-shrink-0"
      aria-label="Imagen siguiente"
    >
      <i class="fas fa-chevron-right text-xl"></i>
    </button>
  </div>
</div>

<div class="flex items-center justify-center">
  <!-- Flecha izquierda carrusel - solo desktop -->
  <button
    *ngIf="controls && images && images.length > 1"
    (click)="onPrevClick()"
    class="hidden md:flex text-primary hover:text-secondary transition-colors p-3 bg-white rounded-full shadow-md hover:shadow-lg z-10 mr-2 flex-shrink-0"
    aria-label="Imagen anterior"
  >
    <i class="fas fa-chevron-left text-xl"></i>
  </button>

  <div
    *ngIf="images && images.length > 0"
    class="carousel-container relative overflow-hidden text-center mx-2 my-3 md:m-5"
  >
    <!-- Mostrar visor 360 si la imagen actual es de tipo 360 -->
    <div
      *ngIf="isCurrentImage360()"
      class="relative inline-block w-full"
      (click)="$event.stopPropagation()"
      (touchstart)="$event.stopPropagation()"
      (touchmove)="$event.stopPropagation()"
      (touchend)="$event.stopPropagation()"
    >
      <app-image-360-viewer
        [images]="images360"
        [productName]="productName"
        [disableModal]="false"
        class="carousel-360-viewer"
      >
      </app-image-360-viewer>
    </div>

    <!-- Mostrar imagen normal si no es 360 -->
    <div
      *ngIf="!isCurrentImage360()"
      class="relative inline-block cursor-pointer"
      (click)="openZoomModal($event)"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd($event)"
    >
      <img
        *ngFor="let image of images; let i = index"
        [src]="image.file_name"
        [alt]="image.imageAlt"
        [ngClass]="{ 'image-active': selectedIndex === i }"
        class="transition-all rounded-lg"
      />

      <div class="carousel-search-icon">
        <div
          class="bg-white rounded-full inline-flex items-center justify-center w-8 h-8 md:w-10 md:h-10 shadow-md"
        >
          <mat-icon class="material-icons text-lg md:text-xl">search</mat-icon>
        </div>
      </div>
    </div>
  </div>

  <!-- Flecha derecha carrusel - solo desktop -->
  <button
    *ngIf="controls && images && images.length > 1"
    (click)="onNextClick()"
    class="hidden md:flex text-primary hover:text-secondary transition-colors p-3 bg-white rounded-full shadow-md hover:shadow-lg z-10 ml-2 flex-shrink-0"
    aria-label="Imagen siguiente"
  >
    <i class="fas fa-chevron-right text-xl"></i>
  </button>
  <div
    *ngIf="indicators"
    class="absolute right-0 left-0 bottom-0 flex justify-center p-0 mb-4"
  >
    <span
      *ngFor="let dot of images; let i = index"
      [ngClass]="{ active: selectedIndex === i }"
      (click)="selectImage(i)"
      class="dot cursor-pointer h-3 w-3 m-1 bg-white opacity-70 rounded-full hover:opacity-100"
    >
    </span>
  </div>
</div>
<div
  *ngIf="images && images.length > 0"
  class="flex justify-center mt-5 mb-5 gap-2 md:gap-5 px-4 md:px-0"
>
  <div
    *ngFor="let image of images; let i = index"
    (click)="selectImage(i)"
    class="flex rounded-lg shadow-md overflow-hidden h-16 md:h-20 items-center hover:shadow-lg cursor-pointer transition-all relative"
    [class.opacity-100]="selectedIndex === i"
    [class.opacity-70]="selectedIndex !== i"
    [class.scale-105]="selectedIndex === i"
  >
    <img
      [src]="image.file_name"
      [alt]="image.imageAlt"
      [ngClass]="{ 'thumb-active': selectedIndex === i }"
      class="w-16 md:w-20 h-full object-cover"
    />
    <!-- Badge 360 en la miniatura -->
    <div
      *ngIf="image.is360"
      class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 pointer-events-none"
    >
      <mat-icon class="material-icons text-white text-2xl">360</mat-icon>
    </div>
  </div>
</div>

<!--<div class="flex items-center justify-center">
  <button *ngIf="controls" class="text-primary" (click)="onPrevClick()">
    <svg
      width="14"
      height="21"
      viewBox="0 0 14 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 20L2 10.5L13 1"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </button>

  <div
    *ngIf="images && images.length > 0"
    class="carousel-container relative overflow-hidden text-center m-5 rounded-lg"
  >
    <img
      *ngFor="let image of images; let i = index"
      [src]="image.file_name"
      [alt]="image.imageAlt"
      [ngClass]="{ 'image-active': selectedIndex === i }"
      class="transition-all"
    />
    <div
      *ngIf="indicators"
      class="absolute right-0 left-0 bottom-0 flex justify-center p-0 mb-4"
    >
      <span
        *ngFor="let dot of images; let i = index"
        [ngClass]="{ active: selectedIndex === i }"
        (click)="selectImage(i)"
        class="dot cursor-pointer h-3 w-3 m-1 bg-white opacity-70 rounded-full hover:opacity-100"
      >
      </span>
    </div>
  </div>

  <button *ngIf="controls" class="text-primary" (click)="onNextClick()">
    <svg
      width="14"
      height="21"
      viewBox="0 0 14 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L12 10.5L1 20"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </button>
  <div
    *ngIf="indicators"
    class="absolute right-0 left-0 bottom-0 flex justify-center p-0 mb-4"
  >
    <span
      *ngFor="let dot of images; let i = index"
      [ngClass]="{ active: selectedIndex === i }"
      (click)="selectImage(i)"
      class="dot cursor-pointer h-3 w-3 m-1 bg-white opacity-70 rounded-full hover:opacity-100"
    >
    </span>
  </div>
</div>
<div
  *ngIf="images && images.length > 0"
  class="flex justify-center mt-5 mb-5 gap-5"
>
  <div
    *ngFor="let image of images; let i = index"
    class="flex rounded-lg shadow-md overflow-hidden h-20 items-center hover:shadow-lg cursor-pointer opacity-70 hover:opacity-100"
  >
    <img
      [src]="image.file_name"
      [alt]="image.imageAlt"
      [ngClass]="{ 'thumb-active': selectedIndex === i }"
      (click)="selectImage(i)"
      class="w-20"
    />
  </div>
</div>-->
